<template>
	<div class="product-index pt-2">
		<!-- <FunctionTitle :title="mainTitle" /> -->
		<CommonFlame :title="title">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn color="primary" dark @click="openSearchDialog()"
					><v-icon>mdi-search</v-icon>部品調達依頼の検索</v-btn
				>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters class="ma-2 d-flex" justify="end">
					<v-btn color="secondary" class="mb-2" @click="openSearchDialog()"
						><v-icon>mdi-search</v-icon>部品調達依頼の検索</v-btn
					>
				</v-row>
			</template>
			<template v-if="!$vuetify.breakpoint.xs">
				<v-row no-gutters class="ma-2 d-flex" justify="end">
					<v-btn color="primary" dark @click="openNewDialog()">
						<v-icon class="mr-1">mdi-plus</v-icon>部品調達依頼作成
					</v-btn>
				</v-row>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters class="ma-2 d-flex" justify="end">
					<v-btn color="secondary" dark @click="openNewDialog()">
						<v-icon class="mr-1">mdi-plus</v-icon>部品調達依頼作成
					</v-btn>
				</v-row>
			</template>
			<p>※計画外部品の依頼一覧ページ</p>
			<v-container v-if="searchResult()">
				<v-row no-gutters class="my-1"><p class="text-h6">検索内容</p></v-row>
				<v-row no-gutters class="my-1">
					<v-col cols="6" sm="4" v-if="name">
						<v-card outlined
							><v-card-subtitle>部品名</v-card-subtitle><v-divider class="mx-3"></v-divider
							><v-card-title>{{ name }}を含む</v-card-title>
						</v-card>
					</v-col>
					<v-col cols="12" sm="4" v-if="productNumber">
						<v-card outlined
							><v-card-subtitle>製造番号</v-card-subtitle><v-divider class="mx-3"></v-divider
							><v-card-title
								><p class="pre-wrap">{{ productNumber }}を含む</p></v-card-title
							>
						</v-card>
					</v-col>
					<v-col cols="12" sm="4" v-if="startSendDate">
						<v-card outlined
							><v-card-subtitle>依頼日(開始)</v-card-subtitle><v-divider class="mx-3"></v-divider
							><v-card-title
								><p class="pre-wrap">{{ startSendDate | dateFormatter }}</p></v-card-title
							>
						</v-card>
					</v-col>
					<v-col cols="12" sm="4" v-if="endSendDate">
						<v-card outlined
							><v-card-subtitle>依頼日(終了)</v-card-subtitle><v-divider class="mx-3"></v-divider
							><v-card-title
								><p class="pre-wrap">{{ endSendDate | dateFormatter }}</p></v-card-title
							>
						</v-card>
					</v-col>
					<v-col cols="12" sm="4" v-if="startAnswerDate">
						<v-card outlined
							><v-card-subtitle>回答日(開始)</v-card-subtitle><v-divider class="mx-3"></v-divider
							><v-card-title
								><p class="pre-wrap">{{ startAnswerDate | dateFormatter }}</p></v-card-title
							>
						</v-card>
					</v-col>
					<v-col cols="12" sm="4" v-if="endAnswerDate">
						<v-card outlined
							><v-card-subtitle>回答日(終了)</v-card-subtitle><v-divider class="mx-3"></v-divider
							><v-card-title
								><p class="pre-wrap">{{ endAnswerDate | dateFormatter }}</p></v-card-title
							>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="requirements"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="openShowDialog(item.id)">
							<td v-if="item.answer">{{ requirementStatus(item) }}</td>
							<td v-else>未処理</td>
							<td>{{ componentName(item) }}</td>
							<td v-if="item.ordered_product">{{ item.ordered_product.product_number }}</td>
							<td v-else>対象製番なし</td>
							<td>{{ item.subtitle }}</td>
							<td>{{ item.from_department.name }}</td>
							<td>{{ item.user.full_name }}</td>
							<td>{{ item.responder ? item.responder.full_name : "" }}</td>
							<td>{{ item.requirement_date | dateFormatter }}</td>
							<td>{{ item.deadline | dateFormatter }}</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</CommonFlame>
		<ComponentProcurementRequirementsSearchDialog
			:dialog.sync="searchDialog"
			@search-requirements="searchRequirements"
		/>
		<ComponentProcurementRequirementsShowDialog
			:dialog.sync="showDialog"
			:requirement_id="requirement_id"
			:requirements="requirements"
			@reload="updateStatusId"
		/>
		<ComponentsAndOrderComponentProcurementRequirementsNewDialog :dialog.sync="newDialog" />
		<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import ComponentProcurementRequirementsSearchDialog from "./components/ComponentProcurementRequirementsSearchDialog.vue"
import ComponentProcurementRequirementsShowDialog from "./components/ComponentProcurementRequirementsShowDialog.vue"
import ComponentsAndOrderComponentProcurementRequirementsNewDialog from "./components/ComponentsAndOrderComponentProcurementRequirementsNewDialog.vue"
import moment from "moment"
import "moment/locale/ja"
import PaginationModule from "../../modules/PaginationModule.vue"

export default {
	filters: {
		dateFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("YYYY/MM/DD(dd)")
		},
	},
	components: {
		CommonFlame,
		FunctionTitle,
		ComponentProcurementRequirementsSearchDialog,
		ComponentProcurementRequirementsShowDialog,
		ComponentsAndOrderComponentProcurementRequirementsNewDialog,
		PaginationModule,
	},
	data() {
		return {
			mainTitle: "",
			title: "部品調達回答済み一覧",
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			headers: [
				{
					text: "依頼状況",
					value: "",
					width: "170px",
					class: "px-1 font-size-075rem",
				},
				{
					text: "部品名",
					value: "",
					width: "200px",
					class: "px-1 font-size-075rem",
				},
				{
					text: "製造番号",
					value: "",
					width: "200px",
					class: "px-1 font-size-075rem",
				},
				{
					text: "サブタイトル",
					value: "",
					width: "200px",
					class: "px-1 font-size-075rem",
				},

				{
					text: "依頼元部門",
					value: "",
					width: "150px",
					class: "px-1 font-size-075rem",
				},
				{
					text: "依頼者",
					value: "",
					width: "150px",
					class: "px-1 font-size-075rem",
				},
				{
					text: "担当者",
					value: "",
					width: "150px",
					class: "px-1 font-size-075rem",
				},
				{
					text: "依頼発行日",
					value: "",
					width: "150px",
					class: "px-1 font-size-075rem",
				},
				{
					text: "希望納期",
					value: "",
					width: "150px",
					class: "px-1 font-size-075rem",
				},
			],
			searchDialog: false,
			showDialog: false,
			newDialog: false,
			requirements: [],
			requirement_id: null,
			authority_flag: false,
			q: {
				sorts: "updated_at desc",
			},
			name: "",
			productNumber: "",
			startSendDate: "",
			endSendDate: "",
			startAnswerDate: "",
			endAnswerDate: "",
			order_components: [],
		}
	},
	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()
		this.fetchRequirements(this.q, page)
	},
	methods: {
		componentName(requirement) {
			const value = requirement.requirement_values.find((value) => {
				return (
					value.requirement_column.name == "製品部品" || value.requirement_column.name == "部品"
				)
			})
			return value.value.name
		},

		requirementStatus(requirement) {
			const value = requirement.answer.answer_values.find((value) => {
				return value.answer_column.name == "依頼状況"
			})
			return value ? value.value : ""
		},

		setQuery() {
			const query = this.$route.query
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					// this.q[query_key] = this.formatQuery(query[query_key])
					this.$set(this.q, query_key, this.formatQuery(query[query_key]))
				}
			})
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
		openNewDialog() {
			this.newDialog = true
		},

		openSearchDialog() {
			this.searchDialog = true
		},
		openShowDialog(requirement_id) {
			this.requirement_id = requirement_id
			this.showDialog = true
		},

		getPage(page) {
			this.fetchRequirements(this.q, page)
			this.$router.push({
				name: "component_procurement_answers_index",
				query: { page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},

		fetchRequirements(q, page) {
			const headers = authenticate.setHeader()
			const params = { page: page, q: q, answer_flag: true }
			this.name = this.$route.query.requirement_values_value_target_type_name_cont
			this.productNumber = this.$route.query.ordered_product_product_number_cont
			this.startSendDate = this.$route.query.requirement_date_gteq
			this.endSendDate = this.$route.query.requirement_date_lteq
			this.startAnswerDate = this.$route.query.answer_created_at_gteq
			this.endAnswerDate = this.$route.query.answer_created_at_lteq

			axios
				.get("/erp/v1/component_procurement_requirements/component_procurement_requirements", {
					params,
					headers,
				})
				.then((res) => {
					this.requirements = res.data.requirements
					this.order_components = res.data.order_components
					this.pagination = res.data.pagination
					this.authority_flag = res.data.authority_flag
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},

		searchRequirements(params) {
			this.q = params.q
			this.$router.push({
				name: "component_procurement_answers_index",
				query: params.q,
			})
			this.fetchRequirements(params.q, 1)
			this.searchDialog = false
		},
		updateStatusId(requirement) {
			const index = this.requirements.findIndex((item) => item.id === requirement.id)
			if (index >= 0) {
				this.requirements.splice(index, 1, requirement)
			}
		},
		searchResult() {
			return (
				this.name ||
				this.productNumber ||
				this.startSendDate ||
				this.endSendDate ||
				this.startAnswerDate ||
				this.endAnswerDate
			)
		},
	},
}
</script>

<style scoped lang="scss"></style>
